._container_n0yjc_1 {
  display: flex; }

._dots_n0yjc_4 {
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--color-b-50);
  border-radius: 50px;
  width: 48px;
  height: 24px;
  padding: 0 8px;
  box-sizing: border-box;
  flex-shrink: 0;
  margin-right: 8px; }
  [data-theme="chat-theme-dark"] ._dots_n0yjc_4 {
    background: var(--color-d-02); }

@container chat (max-width: 470px) {
  ._dots_n0yjc_4 {
    height: 20px; } }

._dot_n0yjc_4 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--color-b-20);
  margin-right: 2px;
  animation: _animateDots_n0yjc_1 1.8s var(--delay) ease-in-out infinite; }
  [data-theme="chat-theme-dark"] ._dot_n0yjc_4 {
    background: var(--color-d-05); }
  ._dot_n0yjc_4:nth-child(1) {
    --delay: 0.2s; }
  ._dot_n0yjc_4:nth-child(2) {
    --delay: 0.3s; }
  ._dot_n0yjc_4:nth-child(3) {
    --delay: 0.4s;
    margin-right: 0; }

._status_n0yjc_40 {
  opacity: 0.3 !important;
  width: auto;
  color: black !important; }
  [data-theme="chat-theme-dark"] ._status_n0yjc_40 {
    color: white !important; }

@container chat (max-width: 470px) {
  ._status_n0yjc_40 {
    font-size: var(--text-font-size-slim) !important;
    line-height: var(--text-line-height-slim) !important; } }

@keyframes _animateDots_n0yjc_1 {
  0%,
  44% {
    transform: translateY(0); }
  28% {
    opacity: 0.85;
    transform: translateY(-3px); }
  44% {
    opacity: 0.75; } }
